/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 表示ステータス
 * @export
 * @interface GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus
 */
export interface GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus {
    /**
     * ログインページ表示有無
     * @type {boolean}
     * @memberof GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus
     */
    login?: boolean;
    /**
     * プロダクト内右下表示有無
     * @type {boolean}
     * @memberof GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus
     */
    lowerRight?: boolean;
}

/**
 * Check if a given object implements the GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus interface.
 */
export function instanceOfGetEnterpriseSystemSettings200ResponseSettingsDisplayStatus(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusFromJSON(json: any): GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus {
    return GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusFromJSONTyped(json, false);
}

export function GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'login': !exists(json, 'login') ? undefined : json['login'],
        'lowerRight': !exists(json, 'lower_right') ? undefined : json['lower_right'],
    };
}

export function GetEnterpriseSystemSettings200ResponseSettingsDisplayStatusToJSON(value?: GetEnterpriseSystemSettings200ResponseSettingsDisplayStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'login': value.login,
        'lower_right': value.lowerRight,
    };
}

